import React from "react";

// STYLES
import styled, {keyframes} from "styled-components";
import Colors from "../../shared/colors"

// ICONS
import MdArrowDropDown from 'react-icons/lib/md/arrow-drop-down';

// ANIMATION
import { fadeIn } from 'react-animations';

export default class Dropdown extends React.Component {
    state = {isOpen:false};

    onClickButton = (to) => {
        this.props.setOrder(to);
        this.openDrop();
    }

    openDrop = () => {
        this.setState({
            isOpen: !this.state.isOpen
        })
    }

    render(){
        let {isOpen} = this.state;
        let {to, t} = this.props;

        const Drop = styled.div `
            margin-left: 22px;
            color: ${this.props.onSrollHeader ? '#FFF' : '#666666'};
            position: relative;
        `

        return(
            <Drop>
                <Button onClick={this.openDrop}>
                    <ButtonText>
                        <ButtonLabel>{t('Ordenar por')}:</ButtonLabel>
                        <ButtonChoose>
                            {
                                this.props.order === 0 && t('Relevância')
                            }
                            {
                                this.props.order === 1 && t('Recente')
                            }
                            {
                                this.props.order === 2 && t('Antigo')
                            }
                            {
                                this.props.order === 3 && 'A - Z'
                            }
                            {
                                this.props.order === 4 && 'Z - A'
                            }
                        </ButtonChoose>
                    </ButtonText>
                    <ButtonIcon><MdArrowDropDown/></ButtonIcon>
                </Button>
                {isOpen && 
                    <span>
                        {
                            to === "restaurants" &&
                                <DropList>
                                    {
                                        this.props.order !== 0 &&
                                            <DropItem onClick={() => this.onClickButton(0)}>
                                                {t('Relevância')}
                                            </DropItem>
                                    }
                                    {
                                        this.props.order !== 3 &&
                                            <DropItem onClick={() => this.onClickButton(3)}>
                                                A - Z
                                            </DropItem>
                                    }
                                    {
                                        this.props.order !== 4 &&
                                            <DropItem onClick={() => this.onClickButton(4)}>
                                                Z - A
                                            </DropItem>
                                    }
                                </DropList>
                        }
                        {
                            to === "products" &&
                                <DropList>
                                    {
                                        this.props.order !== 3 &&
                                            <DropItem onClick={() => this.onClickButton(3)}>
                                                A - Z
                                            </DropItem>
                                    }
                                    {
                                        this.props.order !== 4 &&
                                            <DropItem onClick={() => this.onClickButton(4)}>
                                                Z - A
                                            </DropItem>
                                    }
                                </DropList>
                        }
                        {
                            to === "recipes" &&
                                <DropList>
                                    {
                                        this.props.order !== 3 &&
                                            <DropItem onClick={() => this.onClickButton(3)}>
                                                A - Z
                                            </DropItem>
                                    }
                                    {
                                        this.props.order !== 4 &&
                                            <DropItem onClick={() => this.onClickButton(4)}>
                                                Z - A
                                            </DropItem>
                                    }
                                </DropList>
                        }
                        {
                            to === "events" &&
                                <DropList>
                                    {
                                        this.props.order !== 0 &&
                                            <DropItem onClick={() => this.onClickButton(0)}>
                                               {t('Relevância')}
                                            </DropItem>
                                    }
                                    {
                                        this.props.order !== 1 &&
                                            <DropItem onClick={() => this.onClickButton(1)}>
                                                {t('Recente')}
                                            </DropItem>
                                    }
                                    {
                                        this.props.order !== 2 &&
                                            <DropItem onClick={() => this.onClickButton(2)}>
                                                {t('Antigo')}
                                            </DropItem>
                                    }
                                    {
                                        this.props.order !== 3 &&
                                            <DropItem onClick={() => this.onClickButton(3)}>
                                                A - Z
                                            </DropItem>
                                    }
                                    {
                                        this.props.order !== 4 &&
                                            <DropItem onClick={() => this.onClickButton(4)}>
                                                Z - A
                                            </DropItem>
                                    }
                                </DropList>
                        }
                    </span>
                    
                }
            </Drop>
        );
    }
}

const fadeInAnimation = keyframes`${fadeIn}`;


const Button = styled.div `
    display: flex;
    align-items: center;
    cursor: pointer;
`
const ButtonText = styled.div `
    margin-right: 5px;
`
const ButtonLabel = styled.div `
    font-size: 12px;
    color: #666666;
`
const ButtonChoose = styled.div `
    font-size: 16px;
    color: #666666;
    font-weight: 600;
`
const ButtonIcon =  styled.div `
    font-size: 22px;
`
const DropList = styled.div `
    position: absolute;
    top: 37px;
    background-color: ${Colors.white};
    border-radius: 5px;
    color: ${Colors.text.secondary};
    box-shadow: 0 2px 4px 0 rgba(34,36,38,.12), 0 2px 10px 0 rgba(34,36,38,.15);
    animation: 0.5s ${fadeInAnimation};
    padding-top: 4px;
    padding-bottom: 4px;
`
const DropItem = styled.div `
    padding: 8px 10px;
    font-size: 13px;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    text-transform: uppercase;

    &:hover{
        color: ${Colors.primary};
    }
`



// WEBPACK FOOTER //
// ./src/components/dropdownpage/dropdownpage.component.js